// extracted by mini-css-extract-plugin
module.exports = {"text":"FooterText_text__2rW4l","logo":"FooterText_logo__1Mma_","forceShow":"FooterText_forceShow__17zVb"};